import { render, staticRenderFns } from "./OrderLine.vue?vue&type=template&id=48783a92&scoped=true"
import script from "./OrderLine.vue?vue&type=script&lang=js"
export * from "./OrderLine.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48783a92",
  null
  
)

export default component.exports